import React, { FC, useEffect } from 'react';
import { Modal, Button } from '@clearcover/atlas';
import { reportEvent } from 'Shared/analytics';
import { ClearcoverSupport } from 'Shared/components';
import styles from './styles.module.css';

export type VinNotFoundModalProps = {
  open: boolean;
  vin: string;
  onClose(): void;
};

export const VinNotFoundModal: FC<VinNotFoundModalProps> = ({
  open,
  vin,
  onClose,
}) => {
  useEffect(() => {
    if (open) {
      reportEvent('aqui-vin-not-found-modal-displayed');
    }
  }, [open]);

  return (
    <Modal
      variant="full"
      controlled
      open={open}
      handleClose={onClose}
      showCloseIcon={false}
    >
      {close => (
        <ClearcoverSupport
          testId="vin-not-found-modal"
          title="This vehicle is not in our system"
        >
          <h4>Vehicle Identification Number: {vin.toUpperCase()}</h4>
          <p className={styles.content}>
            Please confirm your entry. If the VIN is correct, contact Clearcover
            Support by chat or call 855-809-2965 for assistance adding the
            vehicle to our system.
          </p>
          <Button data-testid="close-vin-not-found-modal" onClick={close}>
            Back to Quote
          </Button>
        </ClearcoverSupport>
      )}
    </Modal>
  );
};
